import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=1287bc0d"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=1287bc0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports